import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BACKGROUND_COLOR_BLACK, GREY_TEXT_COLOR } from '~/src/features/movix-new/constants';
import { TStyles } from '~/src/features/movix-new/ContentCard';

export const LandingWrapper = styled.div`
    width: 100%;
    overflow: hidden;
    margin-bottom: -50px;
`;

export const MovixButton = styled(Button)`
    ${FONTS.S};
    width: 100%;
`;

export const StyledTrobber = styled(Throbber)`
    position: fixed;
`;

export const ServicesAndTvBlock = styled.div`
    width: 100%;
    position: relative;
    overflow: hidden;
    margin-top: -2px;
    height: 33vw;

    @media (max-width: ${breakPoints.desktop}) {
        height: 43vw;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        height: 50vw;
    }

    @media (max-width: ${breakPoints.tablet}) {
        height: auto;
    }
`;

export const VideoContainer = styled.div<{ backgroundImg: string }>`
    width: 100%;
    position: relative;
    height: 70vw;
    background-color: ${BACKGROUND_COLOR_BLACK};
    background-image: url(${props => props.backgroundImg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: -1px;

    @media (min-width: 1024px) {
      background-position-y: 7px;
      background-size: 87%;
      background-position-x: calc(100% + 40vw);
      top: -105px;
      z-index: 1;
    }

    @media (min-width: 1366px) {
        background-size: 69%;
        background-position-y: 23%;
        background-position-x: 112%;
    }

    @media (min-width: 1601px) {
        background-size: 48.5%;
        background-position-y: 11%;
        background-position-x: 85%;
    }
`;

export const InfoText = styled.div`
    ${FONTS.XXS}
    width: 100%;
    margin-top: 97px;
    margin-bottom: 10px;

    text-align: center;

    color: ${GREY_TEXT_COLOR};

    @media (max-width: ${breakPoints.desktop}) {
      margin-bottom: 132px;
      margin-top: 40px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
      margin-bottom: 117px;
      margin-top: 32px;
    }

    @media (max-width: ${breakPoints.tablet}) {
      margin-bottom: 108px;
      margin-top: 27px;
    }

    @media (max-width: ${breakPoints.mobile}) {
      margin-top: 41px;
      margin-bottom: 50px;
    }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  column-gap: 24px;

  @media (max-width: ${breakPoints.desktop}) {
    column-gap: 22px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    flex-wrap: nowrap;
    column-gap: 16px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    column-gap: 12px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    flex-direction: column;
    row-gap: 24px;
  }
`;

export const Footer = styled.div`
  position: relative;
  width: 100%;
  background: ${BACKGROUND_COLOR_BLACK};
  overflow: hidden;
  margin-top: -1px;

  :before {
    content: '';
    position: absolute;
    width: 3123px;
    height: 1845px;
    left: calc(50% - 1561.5px);
    top: 140px;
    background: radial-gradient(48.12% 30.66% at 50% 54.13%, rgba(15, 80, 240, .59) 0%, rgba(15, 80, 240, 0) 100%);
    mix-blend-mode: normal;
    opacity: 0.35;
  }

  @media (max-width: ${breakPoints.desktop}) {
    :before {
      display: none;
    }
  }

  @media (max-width: ${breakPoints.mobile}) {
    :before {
      display: initial;
      width: 1595px;
      height: 1845px;
      left: calc(50% - 797.5px);
      top: -224px;
    }

    :after {
      content: '';
      position: absolute;
      width: 1595px;
      height: 1845px;
      left: calc(50% - 797.5px);
      bottom: 262px;

      background: radial-gradient(48.12% 30.66% at 50% 54.13%, rgba(15, 80, 240, .59) 0%, rgba(15, 80, 240, 0) 100%);
      mix-blend-mode: normal;
      opacity: 0.35;
    }
  }
`;

export const Container = styled.div`
  max-width: 1503px;
  width: 100%;
  margin: 0 auto;
  z-index: 1;

  @media (max-width: ${breakPoints.desktop}) {
    max-width: 1226px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    max-width: 929px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    max-width: 691px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    max-width: 327px;
  }
`;

export const Title = styled.div<{ marginBottom: number, styles?: TStyles }>`
  ${FONTS.H2};
  color: ${COLORS.TextWhite};
  margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.H3};
  }

  @media (max-width: ${breakPoints.desktop}) {
    margin-bottom: ${({ marginBottom }) => `${marginBottom + 10}px`};
  }

  @media (max-width: ${breakPoints.mobile}) {
    text-align: center;
  }

  ${({ styles }) => styles}
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  background: ${BACKGROUND_COLOR_BLACK};
  overflow: hidden;
  padding: 152px 0;
  margin-top: -1px;

  @media (max-width: ${breakPoints.desktop}) {
    padding-top: 91px;
    padding-bottom: 126px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    padding-top: 77px;
    padding-bottom: 59px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    padding-top: 82px;
    padding-bottom: 58px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    padding-top: 70px;
    padding-bottom: 85px;
  }
`;
